/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'standalone';
const componentName = 'avi-full-modal-preview-message';
const prefix = `${moduleName}.${componentName}`;

export const informationLabel = `${prefix}.informationLabel`;

export const ENGLISH = {
    [informationLabel]: 'Information',
};
